export const SPORT_SELECTOR_INPUT_LABEL = "Sport Filter";
export const DEFAULT_DROPDOWN_ITEM = "None";



// WEBPACK FOOTER //
// ./src/pages/director/dashboard/components/advanced-filters/components/sport-filter/constants.ts